import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ContentsService } from 'src/app/shared/services/contents.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationResolver implements Resolve<any> {

  constructor(private contentsService: ContentsService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<void> {
    if (state.url.includes('/login')) {
      this.contentsService.resetConfigLoaded();
    }
    return this.contentsService.getContentsAndConfigurationsData();
  }
}
